import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCurrentUser } from "../Firebase";

export type PlayerData = {
  uid: string;
  nickname?: string;
  rating?: number;
};

export type PlayersData = {
  playerOne: PlayerData | null;
  playerTwo: PlayerData | null;
  isHost: boolean;
};

export type PlayersDataPayload = {
  playerOne: PlayerData | null;
  playerTwo: PlayerData | null;
};

const initialState: PlayersData = {
  playerOne: null,
  playerTwo: null,
  isHost: false,
};

export const playersSlice = createSlice({
  name: "playersState",
  initialState: initialState,
  reducers: {
    setPlayersState: (
      _,
      action: { type: string; payload: PlayersDataPayload }
    ) => {
      let isHost = false;
      if (action.payload.playerOne != null) {
        isHost = getCurrentUser().uid === action.payload.playerOne.uid;
      }

      return {
        playerOne: action.payload.playerOne,
        playerTwo: action.payload.playerTwo,
        isHost,
      };
    },
    setPlayerNickname: (
      state,
      action: PayloadAction<{ player: "playerOne" | "playerTwo"; nickname: string; rating: number }>
    ) => {
      const p = state[action.payload.player];
      if (p) {
        p.nickname = action.payload.nickname;
        p.rating = action.payload.rating;
      }
    },
    reset: () => initialState,
  },
});

export const { setPlayersState, setPlayerNickname, reset } = playersSlice.actions;

export default playersSlice.reducer;
